import { Injectable } from '@angular/core';

import { Store, select } from '@ngrx/store';

import * as RealtorActions from 'src/app/modules/ngrx-store/realtor/realtor.actions';
import * as RealtorSelectors from 'src/app/modules/ngrx-store/realtor/realtor.selectors';
import * as fromRoot from 'src/app/modules/ngrx-store/reducers';

@Injectable({ providedIn: 'root' })
export class RealtorFacade {
	realtorAccessFailure$ = this.store.pipe(select(RealtorSelectors.getRealtorAccessFailure));
	realtorAccessPending$ = this.store.pipe(select(RealtorSelectors.getRealtorAccessPending));
	realtorAccessSuccess$ = this.store.pipe(select(RealtorSelectors.getRealtorAccessSuccess));
	createRealtorGrantFailure$ = this.store.pipe(select(RealtorSelectors.getCreateRealtorGrantFailure));
	createRealtorGrantPending$ = this.store.pipe(select(RealtorSelectors.getCreateRealtorGrantPending));
	createRealtorGrantSuccess$ = this.store.pipe(select(RealtorSelectors.getCreateRealtorGrantSuccess));
	realtorAccess$ = this.store.pipe(select(RealtorSelectors.getRealtorAccessStatus));
	removeRealtorAccessPending$ = this.store.pipe(select(RealtorSelectors.getRemoveRealtorAccessPending));
	removeRealtorAccessSuccess$ = this.store.pipe(select(RealtorSelectors.getRemoveRealtorAccessSuccess));
	removeRealtorAccessFailure$ = this.store.pipe(select(RealtorSelectors.getRemoveRealtorAccessFailure));
	reactivateRealtorAccessPending$ = this.store.pipe(select(RealtorSelectors.getReactivateRealtorAccessPending));
	reactivateRealtorAccessSuccess$ = this.store.pipe(select(RealtorSelectors.getReactivateRealtorAccessSuccess));
	reactivateRealtorAccessFailure$ = this.store.pipe(select(RealtorSelectors.getReactivateRealtorAccessFailure));
	realtorGrants$ = this.store.pipe(select(RealtorSelectors.getRealtorGrants));
	realtorGrantsFailure$ = this.store.pipe(select(RealtorSelectors.getRealtorGrantsFailure));
	realtorGrantsPending$ = this.store.pipe(select(RealtorSelectors.getRealtorGrantsPending));
	realtorGrantsSuccess$ = this.store.pipe(select(RealtorSelectors.getRealtorGrantsSuccess));
	previewRealtorEmail$ = this.store.pipe(select(RealtorSelectors.getPreviewRealtorEmail));
	visit$ = this.store.pipe(select(RealtorSelectors.getVisit));
	upsertVisitPending$ = this.store.pipe(select(RealtorSelectors.getUpsertVisitPending));
	showClientManagement$ = this.store.pipe(select(RealtorSelectors.showClientManagement));
	openClientManagementModal$ = this.store.pipe(select(RealtorSelectors.getOpenClientManagementModal));

	constructor(protected store: Store<fromRoot.AppDomainPartialState>) {}

	getRealtorAccessStatus() {
		return this.store.dispatch(RealtorActions.loadRealtorAccess());
	}

	acknowledgeRealtorAccess(grantId: string) {
		return this.store.dispatch(RealtorActions.acknowledgeRealtorAccess({ grantId }));
	}

	removeRealtorAccess(grantId: string) {
		return this.store.dispatch(RealtorActions.removeRealtorAccess({ grantId }));
	}

	reactivateRealtorAccess(grantId: string) {
		return this.store.dispatch(RealtorActions.reactivateRealtorAccess({ grantId }));
	}

	createRealtorGrant(marketId: number, salesAgreementId: number, realtorEmail: string) {
		return this.store.dispatch(RealtorActions.createRealtorGrant({ marketId, salesAgreementId, realtorEmail }));
	}

	getRealtorGrants(isPreview: boolean) {
		return isPreview ? this.store.dispatch(RealtorActions.loadRealtorGrantsForPreview()) : this.store.dispatch(RealtorActions.loadRealtorGrants());
	}

	getRealtorGrantsByEmail(realtorEmail: string) {
		return this.store.dispatch(RealtorActions.loadRealtorGrantsByEmail({ realtorEmail }));
	}

	upsertVisit(marketId: number, salesAgreementId: number) {
		return this.store.dispatch(RealtorActions.upsertVisit({ marketId, salesAgreementId }));
	}

	setOpenClientManagementModal(openClientManagementModal: boolean): void {
		this.store.dispatch(RealtorActions.setOpenClientManagementModal({ openClientManagementModal: openClientManagementModal }));
	}
}